{
  "You're invited to watch {title}": "Je bent uitgenodigd om {title} te bekijken",
  "Share your event link": "Deel je evenementlink",
  "device|desktop": "computer",
  "device|phone": "telefoon",
  "device|tablet": "tablet",
  "device|tv": "tv",
  "device|console": "spelcomputer",
  "{hours}h {minutes}m": "{hours} u {minutes} min",
  "Sorry, there's been an error loading the analytics data.": "Sorry, er ging iets mis bij het laden van de statistieken.",
  "Detailed analytics are available for events starting May 20, 2025. Below are the basic statistics for this event.": "Gedetailleerde statistieken zijn beschikbaar voor evenementen vanaf 20 mei 2025. Hieronder zie je de basisstatistieken van dit evenement.",
  "Viewed Live": "Live bekeken",
  "Watched Replay": "Opname bekeken",
  "Powered by": "Mogelijk gemaakt door",
  "{count} views": {
    "one": "{count} weergave",
    "other": "{count} weergaven"
  },
  "{count} viewers": {
    "one": "{count} kijker",
    "other": "{count} kijkers"
  },
  "Total Views": "Totaal aantal weergaven",
  "Unique Viewers": "Unieke kijkers",
  "Total Watch Time": "Totale kijktijd",
  "Views": "Weergaven",
  "Watch Time": "Kijktijd",
  "Top Countries": "Toplanden",
  "Top Regions / States": "Topregio's / staten",
  "analytics|Unknown": "Onbekend",
  "Device Categories": "Apparaatcategorieën",
  "Operating Systems": "Besturingssystemen",
  "Import": "Importeren",
  "Invite a guest": "Gast uitnodigen",
  "We'll email them the event link and remind them before you go live.": "We mailen de gast de evenementlink en sturen een herinnering voordat je live gaat.",
  "CSV Import": "CSV importeren",
  "Select File": "Bestand kiezen",
  "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name": "Formaat: CSV. Verplichte kolom: “Email”. Optionele kolommen: “Name”, “First Name”, “Last Name” (in het Engels)",
  "Invite All ({count})": "Iedereen uitnodigen ({count})",
  "Couldn't load the guest list": "De gastenlijst kon niet worden geladen",
  "Remove the guest from the list?": "Gast van de lijst verwijderen?",
  "guest status|Joined Live": "Live gekeken",
  "guest status|Watched Replay": "Teruggekeken",
  "guest status|Visited page": "Pagina bezocht",
  "guest status|Invited": "Uitgenodigd",
  "{count} guest": {
    "one": "{count} gast",
    "other": "{count} gasten"
  },
  "Open the guest list": "Gastenlijst openen",
  "Guests of every {noun} are on the guest list of {label} (the main link). They sign up once and can watch every {noun}.": "Er is geen aparte gastenlijst per {noun}: alle gasten staan op de gastenlijst van {label} (de hoofdlink). Ze registreren zich één keer en kunnen dan alle streams bekijken.",
  "Start inviting guests": "Nodig je gasten uit",
  "Invite guests by email or just share your event link with them.": "Nodig gasten uit per e-mail of deel gewoon je evenementlink met ze.",
  "Guests who sign the guestbook or ask for reminders appear here too.": "Gasten die het gastenboek tekenen of om herinneringen vragen, verschijnen hier ook.",
  "Share link": "Link delen",
  "Download guest list": "Gastenlijst downloaden",
  "Guests {title}.csv": "Gasten {title}.csv",
  "Guests.csv": "Gasten.csv",
  "{title}-report.pdf": "{title}-rapport.pdf",
  "analytics-report.pdf": "statistiekenrapport.pdf",
  "Export PDF": "PDF exporteren",
  "Invitation sent": "Uitnodiging verstuurd",
  "{name} will get reminders before you go live.": "{name} krijgt herinneringen voordat je live gaat.",
  "Couldn't send the invitation": "De uitnodiging kon niet worden verstuurd",
  "Guest's name": "Naam van de gast",
  "e.g. Maria Lopez": "bijv. Sanne de Jong",
  "Send invitation": "Uitnodiging versturen",
  "Could not open image library.": "De fotobibliotheek kon niet worden geopend.",
  "Delete Cover?": "Omslagafbeelding verwijderen?",
  "Delete failed": "Verwijderen mislukt",
  "Processing image...": "Afbeelding wordt verwerkt...",
  "Uploading... {percent}%": "Uploaden... {percent}%",
  "Invalid file": "Ongeldig bestand",
  "Only JPG or PNG files are accepted": "Alleen JPG- of PNG-bestanden zijn toegestaan",
  "Drop image here": "Laat de afbeelding hier los",
  "Drop image here or click to select": "Sleep een afbeelding hierheen of klik om er een te kiezen",
  "Recommended size: 1280x720 pixels": "Aanbevolen formaat: 1280x720 pixels",
  "Accepts PNG or JPG under 50MB": "PNG of JPG tot 50 MB",
  "Couldn't save that": "Opslaan is niet gelukt",
  "Guests who watch on your website get emails that link back to the page they watched on.": "Gasten die op je website kijken, krijgen e-mails met een link naar de pagina waarop ze hebben gekeken.",
  "Pages where guests watch your embed will show up here.": "Pagina's waarop gasten je embed bekijken, verschijnen hier.",
  "Seen on": "Gezien op",
  "Use for email links": "Gebruiken voor e-maillinks",
  "Ignore": "Negeren",
  "Used for email links": "Gebruikt voor e-maillinks",
  "Stop using": "Niet meer gebruiken",
  "Other guests": "Andere gasten",
  "Your Embed webpage URL from before. Remove it to send everyone else to evt.live.": "De URL van je webpagina met de Embed die je eerder had ingesteld. Verwijder deze om alle anderen naar evt.live te sturen.",
  "EventLive event": "EventLive-evenement",
  "How this event's page looks to guests. It overrides the branding in your profile.": "Zo zien gasten de pagina van dit evenement. Dit gaat voor op de huisstijl in je profiel.",
  "Could not update branding settings": "De huisstijlinstellingen konden niet worden bijgewerkt",
  "Event page": "Evenementpagina",
  "Description": "Beschrijving",
  "A few words for your guests": "Een paar woorden voor je gasten",
  "Supports Markdown: **bold**, lists and links.": "Ondersteunt Markdown: **vet**, lijsten en links.",
  "e.g. 7pm ET / 4pm PT": "bijv. 19:00 Amsterdam / 13:00 New York",
  "Replaces the date and time on your event page and in reminder emails.": "Vervangt de datum en tijd op je evenementpagina en in herinneringsmails.",
  "Company": "Bedrijf",
  "Shown on this event page only. PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best. A white logo on a transparent background may not show on a light page.": "Alleen zichtbaar op de pagina van dit evenement. PNG of JPG; het logo wordt automatisch bijgesneden en geschaald. Horizontale logo's werken het best. Een wit logo op een transparante achtergrond is op een lichte pagina misschien niet te zien.",
  "Put your event page or just the video player on your own website.": "Zet je evenementpagina of alleen de videospeler op je eigen website.",
  "Layout": "Indeling",
  "Full embed": "Volledige embed",
  "The event page: video, guestbook and reminders.": "De evenementpagina: video, gastenboek en herinneringen.",
  "Just video": "Alleen video",
  "Only the video player.": "Alleen de videospeler.",
  "These change the code below. Copy it again after changing them.": "Deze opties veranderen de code hieronder. Kopieer de code opnieuw nadat je ze hebt gewijzigd.",
  "Autoplay": "Automatisch afspelen",
  "Start the video automatically.": "Start de video automatisch.",
  "Reminder button": "Herinneringsknop",
  "Guests can sign up for reminders from your website.": "Gasten kunnen zich via je website aanmelden voor herinneringen.",
  "No replay and no rewind in the embed.": "Niet terugkijken en niet terugspoelen in de embed.",
  "Script (recommended)": "Script (aanbevolen)",
  "Viewers who open an EventLive email link on your page are recognized there, and the player is sized to fit.": "Kijkers die op je pagina een link uit een EventLive-e-mail openen, worden daar herkend, en de speler krijgt automatisch het juiste formaat.",
  "Simple iframe (no script)": "Eenvoudig iframe (zonder script)",
  "For site builders that remove scripts. The player can't see viewers' email links, so ticket holders on a new device may have to sign in again.": "Voor websitebouwers die scripts verwijderen. De speler ziet de e-maillinks van kijkers niet, dus tickethouders moeten op een nieuw apparaat misschien opnieuw inloggen.",
  "Embed code": "Embedcode",
  "Copy embed code": "Embedcode kopiëren",
  "Embed code copied": "Embedcode gekopieerd",
  "Paste it into your website's HTML.": "Plak de code in de HTML van je website.",
  "Preview": "Voorbeeld",
  "Couldn't load the guestbook": "Het gastenboek kon niet worden geladen",
  "Delete this message?": "Dit bericht verwijderen?",
  "Messaging": "Berichten",
  "Chat": "Chat",
  "You pinned": "Vastgezet door jou",
  "Delete this message": "Dit bericht verwijderen",
  "Could not update messaging settings": "De berichtinstellingen konden niet worden bijgewerkt",
  "Guests sign it and add photos. Newest messages first.": "Gasten tekenen het en voegen foto's toe. Nieuwste berichten eerst.",
  "A live chat next to the video, like a group conversation.": "Een livechat naast de video, zoals een groepsgesprek.",
  "Disable messaging": "Berichten uitschakelen",
  "Guests can watch but can't post messages.": "Gasten kunnen kijken, maar geen berichten plaatsen.",
  "{count} message": {
    "one": "{count} bericht",
    "other": "{count} berichten"
  },
  "Loading messages…": "Berichten laden…",
  "No messages yet. They'll appear here as guests post them.": "Nog geen berichten. Ze verschijnen hier zodra gasten ze plaatsen.",
  "Could not update privacy settings": "De privacyinstellingen konden niet worden bijgewerkt",
  "Hide event page": "Evenementpagina verbergen",
  "Manage tickets": "Tickets beheren",
  "Guests need a ticket to watch. To let some guests in for free, invite them from the Guest List.": "Gasten hebben een ticket nodig om te kijken. Wil je sommige gasten gratis toegang geven? Nodig ze dan uit via de gastenlijst.",
  "Anyone with the link can watch": "Iedereen met de link kan kijken",
  "Share the link; no password or invitation needed.": "Deel de link; er is geen wachtwoord of uitnodiging nodig.",
  "Password protected": "Met wachtwoord beveiligd",
  "Guests enter a password you give them.": "Gasten voeren een wachtwoord in dat jij ze geeft.",
  "Choose a password": "Kies een wachtwoord",
  "Invite only": "Alleen op uitnodiging",
  "Only the guests invited by email can join. One device per email at a time. (MUST be on the <list>Guest List</list>)": "Alleen gasten die per e-mail zijn uitgenodigd, kunnen meekijken. Eén apparaat per e-mailadres tegelijk. (Ze MOETEN op de <list>gastenlijst</list> staan)",
  "Ask guests for their name and email": "Gasten om hun naam en e-mailadres vragen",
  "Always on for invite-only events.": "Altijd aan bij evenementen op uitnodiging.",
  "Before they can watch. They'll appear in your Guest List.": "Voordat ze kunnen kijken. Ze verschijnen in je gastenlijst.",
  "Replay and download": "Opname en download",
  "Show download link to guests": "Downloadlink aan gasten tonen",
  "Hide viewer counter": "Kijkersteller verbergen",
  "Your event page is hidden. People who bought tickets can't watch until you show it again.": "Je evenementpagina is verborgen. Mensen die een ticket hebben gekocht, kunnen pas kijken als je de pagina weer zichtbaar maakt.",
  "Your event page is hidden. Guests can't open it until you show it again.": "Je evenementpagina is verborgen. Gasten kunnen de pagina pas openen als je die weer zichtbaar maakt.",
  "Show event page": "Evenementpagina tonen",
  "Remove {guest} from the guest list": "{guest} van de gastenlijst verwijderen",
  "Message pinned": "Bericht vastgezet",
  "Guests see it at the top of the guestbook.": "Gasten zien het bovenaan in het gastenboek.",
  "Couldn't pin the message": "Het bericht kon niet worden vastgezet",
  "e.g. Welcome! The ceremony starts at 3 pm.": "bijv. Welkom! De ceremonie begint om 15:00 uur.",
  "Stays at the top of the guestbook or chat.": "Blijft bovenaan in het gastenboek of de chat staan.",
  "Pin message": "Bericht vastzetten",
  "Share on {network}": "Delen op {network}",
  "Share on Email": "Delen via e-mail",
  "Preview my Event Page": "Mijn evenementpagina bekijken",
  "Share via:": "Delen via:",
  "Viewer-hours": "Kijkuren",
  "{count} viewer-hour": {
    "one": "{count} kijkuur",
    "other": "{count} kijkuren"
  },
  "Live {live} · Replay {replay}": "Live {live} · Opname {replay}",
  "Ticketed events have no viewer-hour limit.": "Evenementen met tickets hebben geen limiet voor kijkuren.",
  "{used} of {limit} viewer-hours included with this event": "{used} van de {limit} kijkuren die bij dit evenement inbegrepen zijn",
  "Over the {limit} viewer-hours included with this event by {over}.": "{over} boven de {limit} kijkuren die bij dit evenement inbegrepen zijn.",
  "By day (UTC)": "Per dag (UTC)",
  "Show fewer days": "Minder dagen tonen",
  "Show all {count} days": {
    "one": "{count} dag tonen",
    "other": "Alle {count} dagen tonen"
  },
  "Viewer-hours are updated every hour. They show here within an hour of people watching.": "Kijkuren worden elk uur bijgewerkt. Ze verschijnen hier binnen een uur nadat mensen hebben gekeken.",
  "Live viewers": "Livekijkers",
  "Devices watching each minute of the live stream.": "Apparaten die per minuut naar de livestream keken.",
  "Live viewers per minute from {start} to {end}. Peak: {peak} at {time}.": "Livekijkers per minuut van {start} tot {end}. Piek: {peak} om {time}.",
  "Peak: {count} at {time}": "Piek: {count} om {time}",
  "{count} viewer at {time}": {
    "one": "{count} kijker om {time}",
    "other": "{count} kijkers om {time}"
  },
  "Browsers and apps": "Browsers en apps",
  "{count} viewer": {
    "one": "{count} kijker",
    "other": "{count} kijkers"
  },
  "Regions:": "Regio's:",
  "IP Geolocation by DB-IP": "IP-geolocatie door DB-IP",
  "Before {date}": "Vóór {date}",
  "From our previous analytics, which counted browsers only, saved for good before they expired.": "Uit onze vorige statistieken, die alleen browsers telden, voorgoed bewaard voordat ze verliepen.",
  "Viewers": "Kijkers",
  "{live} live · {replay} replay only": "{live} live · {replay} alleen teruggekeken",
  "{time} per viewer": "{time} per kijker",
  "Peak live viewers": "Maximaal aantal livekijkers",
  "Watch time, views, countries and devices are counted from {date}. Unique viewers are counted for every event.": "Kijktijd, weergaven, landen en apparaten worden geteld vanaf {date}. Unieke kijkers worden voor elk evenement geteld.",
  "Viewers here are devices on each day: someone watching on two days counts twice. Counted every hour from the video our CDN delivered, on every player.": "Kijkers zijn hier apparaten per dag: iemand die op twee dagen kijkt, telt twee keer. Elk uur geteld op basis van de video die ons CDN heeft geleverd, op elke speler.",
  "Each viewer counts once, however many days they watch. Counted every hour from the video our CDN delivered, on every player.": "Elke kijker telt één keer, op hoeveel dagen hij ook kijkt. Elk uur geteld op basis van de video die ons CDN heeft geleverd, op elke speler.",
  "analytics|Other": "Overig",
  "Analytics are updated every hour. They show here within an hour of people watching.": "Statistieken worden elk uur bijgewerkt. Ze verschijnen hier binnen een uur nadat mensen hebben gekeken.",
  "Counted from {date}; the viewing before it is further down.": "Geteld vanaf {date}; wat daarvoor is bekeken, staat verderop.",
  "Counted from {date}; the viewing before it wasn't counted.": "Geteld vanaf {date}; wat daarvoor is bekeken, is niet geteld.",
  "Live viewing during {times} isn't fully counted: our video network didn't save all its logs for that time.": "Het livekijken tijdens {times} is niet volledig geteld: ons videonetwerk heeft voor die tijd niet alle logs bewaard.",
  "Updated hourly.": "Elk uur bijgewerkt.",
  "Last updated {date}, {time}": "Laatst bijgewerkt: {date}, {time}",
  "analytics|Live": "Live",
  "analytics|Replay": "Opname"
}
